import { firebaseRandomID } from "./helperFunctions";

/**
 * Deep-clone a customSections tree with fresh IDs.
 * @param {Array} sections - The section tree to clone
 * @param {Object} options
 * @param {boolean} options.clearArticleIDs - If true, empty all articleIDs arrays (groups-only mode)
 * @returns {Array} Cloned section tree with new IDs
 */
export const cloneSectionTree = (sections, { clearArticleIDs = false } = {}) =>
  sections.map((section) => ({
    ...section,
    id: firebaseRandomID(),
    ...(section.articleIDs
      ? { articleIDs: clearArticleIDs ? [] : [...section.articleIDs] }
      : {}),
    ...(section.groups
      ? { groups: cloneSectionTree(section.groups, { clearArticleIDs }) }
      : {}),
  }));
